import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 4.274L12 2 4 4.274v8.71c0 3.92 2.977 6.828 7.594 8.87l.332.146.349-.1C18.383 20.165 20 15.332 20 12.985v-8.71zm-14 8.71V5.775l6-1.705 6 1.705v7.21c0 1.595-1.129 5.375-5.93 6.899C7.92 17.972 6 15.627 6 12.984zm8.835-4.746a1.015 1.015 0 011.374.062c.37.376.39.972.043 1.37l-5.062 5.042a1.015 1.015 0 01-1.417 0l-2.025-2.017a1.005 1.005 0 01.043-1.37c.372-.375.97-.402 1.375-.062l1.316 1.311 4.353-4.336z",
      fill: "#2d6ded"
    }
  )
), a = t;
export {
  a as default
};
